import { Permission } from '../permission';

const ADMIN_KEY = 'administrator';

export const ADMINISTRATORS = {
  ADMINISTRATOR_ONLY: new Permission({
    key: `${ADMIN_KEY}:administrator-only`,
    description: 'nur für Administratoren',
  }),
};
